import React, { useContext, useEffect } from 'react';
import MyContext from '../Context/MyContext';
import Alert from '@mui/material/Alert';
import Slide from '@mui/material/Slide';
import './Alert.scss';

const Alerto = () => {
  const { open, setOpen, message } = useContext(MyContext);

  useEffect(() => {
    if (open) {
      const timer = setTimeout(() => {
        setOpen(false);
      }, 5000);
      return () => clearTimeout(timer); 
    }
  }, [open, setOpen]);

  return (
    <>
      <Slide in={open} direction="down" mountOnEnter unmountOnExit>
        <div className="alert-main">
          <Alert severity={message.includes('Thanks') || message.includes('Attendance') ? 'info' : 'error'}>{message}</Alert>
        </div>
      </Slide>
    </>
  );
};

export default Alerto;
